import Container from "@mui/material/Container";
import ErrorComponent from "../component/ErrorComponent";

const Teams = () => {
  return (
    <Container sx={{ marginTop: "100px", marginBottom: "25px" }}>
      <ErrorComponent message="Teams Page is restricted from general access to protect user privacy and consent." />
    </Container>
  );
};

export default Teams;
